import { wrapperBuilder } from './build';
wrapperBuilder
  .getVariablesRegisterInstance()
  .addVariable('institutionAccounts', { startValue: undefined });
